<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="replacementBillVo.pkid > 0 ? '编辑':'新建'"
        width="1500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="replacementBillVo"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-tabs type="border-card">
          <el-tab-pane label="基础信息">
            <el-row>
              <el-col :span="8">
                <el-form-item label="售后单号">
                  <el-input v-model="replacementBillVo.billNo" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户单号">
                  <el-input
                      v-model="replacementBillVo.customerBillNo"
                      @change="getDistinctList(replacementBillVo.customerBillNo)"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="项目号">
                  <el-input v-model="replacementBillVo.faultSerialNO"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="客户名称" prop="customerName">
                  <el-input v-model="replacementBillVo.customerName" readonly placeholder="请输入" clearable>
                    <el-button
                        slot="append"
                        icon="el-icon-search"
                        style="margin-left: 2%;"
                        @click="$refs.selectCustomer.open()">
                      选择
                    </el-button>
                  </el-input>
                  <customer-select ref="selectCustomer" @select="selectCustomer"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="销售员">
                  <el-input v-model="replacementBillVo.salesMan"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出厂编号">
                  <el-input
                      v-model="replacementBillVo.salesOrderNo"
                      @change="getDistinctList(replacementBillVo.salesOrderNo)"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="现场人员">
                  <el-input v-model="replacementBillVo.contact"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系方式-现场">
                  <el-input v-model="replacementBillVo.mobile"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="项目名称">
                  <el-input
                      v-model="replacementBillVo.siteName"
                      placeholder="请输入"
                      @change="getDistinctList(replacementBillVo.siteName)"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="收货人" prop="consignee">
                  <el-input v-model="replacementBillVo.consignee"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系方式-收货" prop="consigneeMobile">
                  <el-input v-model="replacementBillVo.consigneeMobile"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="快递方式" prop="deliveryType">
                  <el-select v-model="replacementBillVo.deliveryType" filterable placeholder="请选择">
                    <el-option
                        v-for="item in constants.deliveryType.$options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="是否过质保" prop="underWarranty">
                  <el-radio-group v-model="replacementBillVo.underWarranty">
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="现场环境" prop="environment">
                  <el-select v-model="replacementBillVo.environment" filterable placeholder="请选择">
                    <el-option
                        v-for="item in constants.environment.$options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="故障发生阶段" prop="stage">
                  <el-select v-model="replacementBillVo.stage" placeholder="请选择发生阶段">
                    <el-option
                        v-for="item in constant.toSelect(constant.stage)"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="是否已技术支持" prop="isTechnicalSupport">
                  <el-radio-group v-model="replacementBillVo.isTechnicalSupport">
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否已质量核实" prop="isSurvey">
                  <el-radio-group v-model="replacementBillVo.isSurvey">
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="运费是否到付" prop="deliveryPaymentType">
                  <el-radio-group v-model="replacementBillVo.deliveryPaymentType">
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否海外" prop="isOverseas">
                  <el-radio-group v-model="replacementBillVo.isOverseas">
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="vm-separate">
              <el-form-item label="电梯编号">
                <el-input
                    v-model="replacementBillVo.elevatorNo"
                    @change="getDistinctList(replacementBillVo.elevatorNo)"/>
              </el-form-item>
            </div>

            <el-form-item label="收货地址" prop="deliveryAddress">
              <el-input
                  v-model="replacementBillVo.deliveryAddress"
                  type="textarea"
                  placeholder="请输入"/>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <el-input
                  v-model="replacementBillVo.note"
                  type="textarea"
                  placeholder="请输入"
                  @change="editNote(replacementBillVo.note)"/>
            </el-form-item>
            <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
              <div slot="toolbar">
                <!--                <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectMaterial.open()">-->
                <!--                  新建有料号-->
                <!--                </el-button>-->
                <el-button type="primary" style="margin-bottom: 10px" @click="getDetails1">
                  新建
                </el-button>
              </div>
              <el-table
                  :data="replacementBillVo.details"
                  border>
                <el-table-column prop="materialNo" width="160" align="center" label="物料编号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.materialNo" placeholder="请输入" @change="(val) => changeMaterialNo(scope.row, val)">
                      <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="materialDesc" width="200" align="center" label="物料名称">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.materialDesc" placeholder="请输入" autosize type="textarea"/>
                  </template>
                </el-table-column>
                <el-table-column prop="materialType" width="150" align="center" label="产品分类">
                  <template slot-scope="scope">
                    <el-select
                        v-model="scope.row.materialType"
                        filterable
                        clearable
                        size="mini"
                        placeholder="请选择">
                      <el-option
                          v-for="item in constants.materialType.$options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          @click.native="changeMaterialType(scope.row)"/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="originalSoftware" width="130" align="center" label="原程序号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.originalSoftware" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="presentSoftware" width="130" align="center" label="现程序号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.presentSoftware" type="textarea" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="mainPartsSerialNo"
                    width="130"
                    align="center"
                    label="变频器/板卡序列号">
                  <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.mainPartsSerialNo"
                        type="textarea"
                        placeholder="请输入"
                        @change="getDistinctList(scope.row.mainPartsSerialNo)"/>
                  </template>
                </el-table-column>
                <el-table-column prop="faultCode" width="100" align="center" label="故障码">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.faultCode" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="faultType" width="120" align="center" label="故障分类">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.faultType" clearable size="mini" placeholder="请选择">
                      <el-option
                          v-for="item in constants.faultType.$options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="quantity" width="100" align="center" label="数量">
                  <template slot-scope="scope">
                    <!--                    <el-input-number v-model="scope.row.quantity" :precision="2" :step="1"/>-->
                    <el-input v-model="scope.row.quantity" placeholder="请输入" @change="changeMaterialType(scope.row, true)"/>
                  </template>
                </el-table-column>
                <el-table-column prop="unit" width="100" align="center" label="单位">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.unit" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="deliveryNote" width="120" align="center" label="备注">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.deliveryNote" placeholder="请输入" autosize type="textarea"/>
                  </template>
                </el-table-column>
                <el-table-column prop="isNewRequest" width="100" align="center" label="是否新件">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.isNewRequest" clearable size="mini" placeholder="请选择">
                      <el-option label="否" :value="0"/>
                      <el-option label="是" :value="1"/>
                      <el-option label="可新可旧" :value="2"/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="problemType" width="120" align="center" label="问题分类">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.problemType" clearable size="mini" placeholder="请选择">
                      <el-option
                          v-for="item in constants.problemType2.$options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="responsibleDept" width="120" align="center" label="责任部门">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.responsibleDept" clearable size="mini" placeholder="请选择">
                      <el-option
                          v-for="item in constants.responsibleDepartment.$options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="deliveryType" width="130" align="center" label="发运类型">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.deliveryType" placeholder="请选择">
                      <el-button slot="append" icon="el-icon-search" @click="$refs.deliverySelect.open(scope.$index)"/>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="deliveryPerson" width="120" align="center" label="发运人"/>
                <el-table-column prop="deliveryBillNo" width="120" align="center" label="发运单号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.deliveryBillNo" type="textarea" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="serialNo" width="120" align="center" label="发出-序列号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.serialNo" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="deliveryWay" width="120" align="center" label="发运方式">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.deliveryWay" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="isMustBack" width="100" align="center" label="是否必退">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.isMustBack" clearable size="mini" placeholder="请选择">
                      <el-option label="是" :value="true"/>
                      <el-option label="否" :value="false"/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    class-name="vm-table_operate"
                    width="100px">
                  <template slot-scope="scope">
                    <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <material-c-s-select ref="selectMaterial" @select="getDetails"/>
            </div>
            <div>
              <div
                  style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
                订单附件
              </div>
              <div>
                <el-upload
                    action=""
                    multiple
                    :http-request="submitUpload"
                    :show-file-list="false"
                    :disabled="uploadLoading"
                    style="display: inline-block; float: left; margin: 5px;">
                  <el-button type="primary" plain>
                    <i class="el-icon-upload el-icon--right"/>
                    附件上传
                  </el-button>
                </el-upload>
              </div>
              <el-table
                  v-if="replacementBillVo.attachments"
                  ref="payData1"
                  :data="replacementBillVo.attachments">
                <el-table-column type="index" align="center" label="行号"/>
                <el-table-column prop="fileName" align="center" label="图片">
                  <template slot-scope="scope">
                    <el-image
                        style="width: 50px; height: 50px;margin-right: 10px"
                        :src="scope.row.imgUrl"
                        :preview-src-list="imgUrls"/>
                  </template>
                </el-table-column>
                <el-table-column prop="fileName" align="center" label="附件描述">
                  <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.fileName"
                        class="tabInput"
                        style="width: 400px;margin: 0 auto;text-align: center"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
                  <template slot-scope="scope">
                    <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <delivery-type-select ref="deliverySelect" @select="deliverySelect"/>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSave">保存</el-button>
        <el-button :loading="submitLoading" type="success" @click="handleSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import constants from "@/util/constants.js";
  import MaterialCSSelect from "@/views/afterSalesManagement/Replacement/MaterialCSSelect";
  import DeliveryTypeSelect from "@/views/afterSalesManagement/Replacement/DeliveryTypeSelect";
  import smartParse from "address-smart-parse";

  export default {
    name: "",
    components: {DeliveryTypeSelect, MaterialCSSelect, CustomerSelect},
    data() {
      return {
        constant,
        constants,
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        imgUrls: [],
        files: [],
        fileList: [],
        replacementBillVo: {
          pkid: 0,
          billNo: "",
          customerBillNo: "",
          elevatorNo: "",
          salesMan: "",
          createTime: "",
          creatorName: loginUtil.getName(),
          faultSerialNO: "",
          customerId: "",
          customerName: "",
          factoryNo: "",
          salesOrderNo: "", //出厂编号
          environment: "",
          underWarranty: false,
          isFreightCollect: false, //
          deliveryPaymentType: false, //
          isTechnicalSupport: "",
          isSurvey: "",
          isOverseas: "",
          contact: "",
          mobile: "",
          stage: "",
          consignee: "",
          deliveryType: "",
          deliveryAddress: "",
          note: "",
          attachments: [],
          details: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
          consignee: {required: true, message: "不能为空", trigger: "blur"},
          consigneeMobile: {required: true, message: "不能为空", trigger: "blur"},
          environment: {required: true, message: "不能为空", trigger: "blur"},
          stage: {required: true, message: "不能为空", trigger: "blur"},
          isTechnicalSupport: {required: true, message: "不能为空", trigger: "blur"},
          isSurvey: {required: true, message: "不能为空", trigger: "blur"},
          deliveryType: {required: true, message: "不能为空", trigger: "blur"},
          deliveryPaymentType: {required: true, message: "不能为空", trigger: "blur"},
          deliveryAddress: {required: true, message: "不能为空", trigger: "blur"},
          note: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.replacementBillVo.pkid = row.pkid;
        this.dialogVisible = true;
        if (this.replacementBillVo.pkid > 0) {
          this.getData();
        }
        // this.getTemplateList();
      },
      changeMaterialType(item, isCalculate = false) {
        console.log(item);
        let isMustBack = false;
        if (parseInt(item.quantity) >= 1 && item.materialType) {
          if (item.materialType.includes("主板") || item.materialType.includes("轿厢板") || item.materialType.includes("指令板") || item.materialType.includes("显示板")
            || item.materialType.includes("辅助类板卡") || item.materialType.includes("一体机") || item.materialType.includes("控制柜")
            || item.materialType.includes("电源类") || item.materialType.includes("人机类") || item.materialType.includes("轿顶箱")
            || item.materialType.includes("物联网") || item.materialType.includes("大线") || item.materialType.includes("井道配件")) {
            isMustBack = true;
          }
          if (item.materialType.includes("按钮类") && parseInt(item.quantity)<=10) {
            isMustBack = true;
          }
        }
        item.isMustBack = isMustBack;
        if(isCalculate) {
          this.calculateAmount(item);
        }
      },
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      editDeliveryAddress(val) {
        let text = smartParse(this.replacementBillVo.deliveryAddress);
        this.replacementBillVo.deliveryAddress = text.province + text.city + text.county + text.address;
        if (this.replacementBillVo.consignee === "") {
          this.replacementBillVo.consignee = text.name;
        }
        if (this.replacementBillVo.consigneeMobile === "") {
          this.replacementBillVo.consigneeMobile = text.phone;
        }
      },
      editNote(val) {
        this.replacementBillVo.note = val.replace(/\s+/g, "");
      },
      getDistinctList(val) {
        if (val) {
          let params = {
            "filter": val.replace(/\s+/g, ""),
          };
          this.$http
            .get("basic", "replacementBills/getDistinctList", params)
            .then((res) => {
              if (res) {
                alert(val + "：存在重复的历史售后申请：单号为" + res);
              }
            });
        }
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.replacementBillVo.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.replacementBillVo.attachments.forEach(row => {
              if (row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              } else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      deliverySelect(row) {
        this.replacementBillVo.details[row.groupIndex].deliveryType = row.deliveryTypeName;
        this.replacementBillVo.details[row.groupIndex].deliveryPerson = row.userName;
        this.replacementBillVo.details[row.groupIndex].deliveryAccount = row.account;
        this.replacementBillVo.details[row.groupIndex].setTime = row.setTime;
      },
      getData() {
        this.$http
          .get("basic", `replacementBills/${this.replacementBillVo.pkid}`)
          .then(resp => {
            this.replacementBillVo = resp;
            this.replacementBillVo.attachments.forEach(row => {
              if (row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              } else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
          });
      },
      changeMaterialNo(row, val) {
        this.$http
          .get("basic", `sAPSaleOrderDetails/materialNo/${val}`)
          .then(resp => {
            row.price = resp.price;
            this.calculateAmount(row);
          });
      },
      getDetails(row, index) {
        this.replacementBillVo.details[index].materialId = row.id;
        this.replacementBillVo.details[index].materialDesc = row.name;
        this.replacementBillVo.details[index].materialNo = row.no;
        this.changeMaterialNo(this.replacementBillVo.details[index], row.no);
      },
      //计算总金额
      calculateAmount(row) {
        const amount = parseFloat(row.price) * parseFloat(row.quantity);
        this.$set(row, "amount", (amount || 0).toFixed(3));
      },
      getDetails1() {
        this.replacementBillVo.details.push({
          pkid: 0,
          masterId: 0,
          materialId: -1,
          materialDesc: "",
          materialNo: "",
          deliveryPerson: "",
          deliveryType: "",
          deliveryAccount: "",
          quantity: 0,
          unit: "",
        });
      },
      natureTypeChange(value) {
        console.log(value);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "https://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      //附件表页面删除
      fileDelete(row, index) {
        console.log(row);
        this.replacementBillVo.attachments.splice(index, 1);
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      oneDelete(index) {
        this.replacementBillVo.details.splice(index, 1);
      },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.replacementBillVo.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      selectCustomer(row) {
        // console.log(row);
        this.replacementBillVo.customerName = row.customerName;
        this.replacementBillVo.customerId = row.customerID;
        this.getSalesmanList(row.customerID);
      },
      getSalesmanList(customerID) {
        this.salesmanList = [];
        this.$http
          .get("basic", `customerBelongtoEmployees/customerId/${customerID}`)
          .then(res => {
            if (res.length > 0) {
              res.forEach(item => {
                if (item.isDefault) {
                  console.log(item.employeeName);
                  this.replacementBillVo.salesMan = item.employeeName;
                }
              });

            }
          });
      },
      handleSave() {
        this.submitLoading = true;
        this.replacementBillVo.isSubmit = false;
        if (this.replacementBillVo.pkid > 0) {
          this.$http
            .put("basic", "replacementBills", this.replacementBillVo)
            .then(() => {
              this.submitLoading = false;
              // this.dialogVisible = false;
              // this.$emit("save-success");
              this.$message.success("保存成功");
              if (this.replacementBillVo.status === 20) {
                let weChatVo = {
                  userName: "lilan|wangwj",
                  content: "更换单内容已修改，请留意，单号：" + this.replacementBillVo.billNo,
                };
                this.$http.post("basic", "replacementBills/pushWeChat_noApprove", weChatVo).then(() => {
                  // this.$message.success("");
                }).catch(() => {
                  this.submitLoading = false;
                });
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        } else {
          this.$http
            .post("basic", "replacementBills", this.replacementBillVo)
            .then((res) => {
              this.submitLoading = false;
              // this.dialogVisible = false;
              // this.$emit("save-success");
              this.replacementBillVo.pkid = res.data;
              this.getData();
              this.$message.success("保存成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      },
      submit(pkid) {
        this.$http.get("basic", "replacementBills/status/" + pkid).then(() => {
        });
      },
      handleSubmit() {
        console.log(this.replacementBillVo.details);
        if (this.replacementBillVo.details.length === 0) {
          return this.$message.error("物料信息不能为空！");
        }
        this.replacementBillVo.details.forEach(item => {
          if (item.quantity === "" || item.quantity === 0) {
            return this.$message.error("物料数量不能为0！");
          } else if (item.materialDesc === "") {
            return this.$message.error("物料名称不能为空");
          } else if (item.materialType === "") {
            return this.$message.error("产品分类能为空");
          } else if (item.unit === "") {
            return this.$message.error("单位能为空");
          }

        });
        if (this.replacementBillVo.pkid > 0) {
          this.$refs.form.validate(valid => {
            if (valid) {
              this.submitLoading = true;
              this.$http
                .put("basic", "replacementBills", this.replacementBillVo)
                .then(() => {
                  this.submit(this.replacementBillVo.pkid);
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("提交成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          });

        } else {
          this.$refs.form.validate(valid => {
            if (valid) {
              this.submitLoading = true;
              this.replacementBillVo.isSubmit = false;
              this.$http
                .post("basic", "replacementBills/insertAndSubmit", this.replacementBillVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("提交成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          });
        }

      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
